module.exports = __webpack_public_path__ + "img/moving.717d663e.png";